import React from 'react';
import { ReactComponent as ExclamationIcon } from '../../images/icons/exclamation_circle.svg';

export default function UnpublishedOrgBanner () {
    return (
        <div className="unpublished-banner">
            <p>
                <span className="ub-title">
                    <span className="ub-icon">
                        <ExclamationIcon />
                    </span>
                    Important:{' '}
                </span>
                Your organisation is unverified.{' '}
                <span className="ub-extra-copy">
                    Our team is reviewing your submission and will update the status soon.
                </span>
            </p>
        </div>
    );
}
